<app-template-checkbox [disabled]="disabled" [value]="value" [control]="control" [label]="label" />
